import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen bg-navy text-slate-400 font-sans selection:bg-gold selection:text-navy flex flex-col" data-id="element-138">
      <Header data-id="element-139" />
      <main className="flex-grow" data-id="element-140">
        <Outlet data-id="element-141" />
      </main>
      <Footer data-id="element-142" />
    </div>;
}